var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};
export default function hyphenateStyleName(prop) {
  return prop in cache ? cache[prop] : cache[prop] = prop.replace(uppercasePattern, "-$&").toLowerCase().replace(msPattern, "-ms-");
}